
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import venta_actual from './estadisticas-inicio-venta-actual.vue';

    import venta_cliente from './estadisticas-inicio-venta-cliente.vue';
    import venta_articulo from './estadisticas-inicio-venta-articulo.vue';
    import venta_viajante from './estadisticas-inicio-venta-viajante.vue';

    import venta_general from './estadisticas-inicio-venta-general.vue';
    import venta_ml from './estadisticas-inicio-venta-mercadolibre.vue';
    import venta_intex from './estadisticas-inicio-venta-intex.vue';
import { Cliente } from '@/__env/lib/Clientes';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            venta_actual,
            venta_general,
            venta_cliente,
            venta_articulo,
            venta_viajante,
            venta_ml,
            venta_intex,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public MenuAbierto: boolean = false;
        public Buscador: string = '';
        public Estado: string = '';
        public SubModo: string = '';
        public Modo: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Buscador = this.Controlador.Vista.Buscador;
            this.Estado = this.Controlador.Vista.Estado;
            this.Modo = this.Controlador.Vista.Modo;
            this.Eventos.push( this.Controlador.Vista.onBuscador.subscribe( () => this.Buscador = this.Controlador.Vista.Buscador ) );
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );
            this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () => this.Modo = this.Controlador.Vista.Modo ) );
            this.Eventos.push( this.Controlador.Vista.onSubModo.subscribe( () => this.SubModo = this.Controlador.Vista.SubModo ) );
            this.Eventos.push( this.Controlador.Vista.onMenuAbierto.subscribe( () => this.MenuAbierto = this.Controlador.Vista.MenuAbierto ) );

            this.Controlador.Iniciar();
        }


    }
